import {
    EMP_DASH_INIT,
    EMP_DASH_CIRCULAR_INIT,
    EMP_DASH_CIRCULAR_DONE,
    EMP_DASH_REMINDERS_INIT,
    EMP_DASH_REMINDERS_DONE,
    EMP_DASH_TILES_INIT,
    EMP_DASH_TILES_DONE,
    EMP_DASH_UPDATES_INIT,
    EMP_DASH_UPDATES_DONE,
    EMP_DASH_PERFORMANCE_INIT,
    EMP_DASH_PERFORMANCE_DONE,
    EMP_DASH_SALES_INIT,
    EMP_DASH_SALES_DONE,
    EMP_DASH_NOTICES_INIT,
    EMP_DASH_NOTICES_DONE,
    EMP_DASH_BENEFITS_INIT,
    EMP_DASH_BENEFITS_DONE,
    EMP_DASH_INTERVIEWS_INIT,
    EMP_DASH_INTERVIEWS_DONE,
    EMP_DASH_EMP_DETAILS_INIT,
    EMP_DASH_EMP_DETAILS_DONE,
} from "../actions/EmpDashboard.action";

const initialState = {
    isCircularCalling: false,
    circulars: [],
    isReminderCalling: false,
    reminders: {
        birthdays: [],
        workAnniversaries: [],
        marriageAnniversaries: [],
    },
    isTilesCalling: false,
    tiles: {
        theme: null,
        utsavImages: [],
        utsavEvents: [],
        joined: [],
        separated: [],
        announcements: [],
        noticeboard: null,
        benefits: [],
    },
    isUpdatesCalling: false,
    myUpdates: [],
    isNoticesCalling: false,
    notices: [],
    isBenefitsCalling: false,
    benefitsImages: [],
    isInterviewsCalling: false,
    interviewCounts: null,
    isPerformanceCalling: false,
    performance: null,
    isSalesCalling: false,
    salesTarget: null,
    isEmpDetailsCalling: false,
    empDetails: null,
};

export default function empDashboardReducer(state = JSON.parse(JSON.stringify(initialState)), action) {
    switch (action.type) {
        case EMP_DASH_INIT:
            return { ...state };
        case EMP_DASH_CIRCULAR_INIT:
            return { ...state, isCircularCalling: true };
        case EMP_DASH_CIRCULAR_DONE:
            return { ...state, isCircularCalling: false, circulars: action.payload };
        case EMP_DASH_REMINDERS_INIT:
            return { ...state, isReminderCalling: true };
        case EMP_DASH_REMINDERS_DONE:
            return { ...state, isReminderCalling: false, reminders: { ...state.reminders, ...action.payload } };
        case EMP_DASH_TILES_INIT:
            return { ...state, isTilesCalling: true };
        case EMP_DASH_TILES_DONE:
            return { ...state, isTilesCalling: false, tiles: { ...state.tiles, ...action.payload } };
        case EMP_DASH_UPDATES_INIT:
            return { ...state, isUpdatesCalling: true };
        case EMP_DASH_UPDATES_DONE:
            return { ...state, isUpdatesCalling: false, myUpdates: action.payload || [] };
        case EMP_DASH_PERFORMANCE_INIT:
            return { ...state, isPerformanceCalling: true };
        case EMP_DASH_PERFORMANCE_DONE:
            return { ...state, isPerformanceCalling: false, performance: action.payload };
        case EMP_DASH_SALES_INIT:
            return { ...state, isSalesCalling: true };
        case EMP_DASH_SALES_DONE:
            return { ...state, isSalesCalling: false, salesTarget: action.payload };
        case EMP_DASH_NOTICES_INIT:
            return { ...state, isNoticesCalling: true };
        case EMP_DASH_NOTICES_DONE:
            return { ...state, isNoticesCalling: false, notices: action.payload || [] };
        case EMP_DASH_BENEFITS_INIT:
            return { ...state, isBenefitsCalling: true };
        case EMP_DASH_BENEFITS_DONE:
            return { ...state, isBenefitsCalling: false, benefitsImages: action.payload || [] };
        case EMP_DASH_INTERVIEWS_INIT:
            return { ...state, isInterviewsCalling: true };
        case EMP_DASH_INTERVIEWS_DONE:
            return { ...state, isInterviewsCalling: false, interviewCounts: action.payload };
        case EMP_DASH_EMP_DETAILS_INIT:
            return { ...state, isEmpDetailsCalling: true };
        case EMP_DASH_EMP_DETAILS_DONE:
            return { ...state, isEmpDetailsCalling: false, empDetails: action.payload };
        default:
            return state;
    }
}
